var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-check-button-icon",on:{"click":function($event){$event.preventDefault();return _vm.onClickCheck.apply(null, arguments)}}},[_c('i',{class:[
      'g-check-button-icon__check',
      { 'g-check-button-icon__check--checked': _vm.checked }
    ]})])}
var staticRenderFns = []

export { render, staticRenderFns }